import React from 'react';

const LeftShape = ({ className }) => {
  return (
    <svg 
      className={className}
      width="195" 
      height="305" 
      viewBox="0 0 195 305" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M-3.32366 311.872C9.58927 312.616 245.43 252.388 181.347 127.201C140.208 82.9543 100.562 191.413 77.0755 119.647C57.6505 60.2912 50.6365 -44.9301 -3.32365 26.2967" 
      stroke="#9DBCC5" 
      stroke-width="4.5" 
      stroke-dasharray="6 6"/>
    </svg>
  );
};

export default LeftShape;
